import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { ControlContainer, NgForm, NgModel } from '@angular/forms';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-edit-names-mat',
    templateUrl: './fi-edit-names-mat.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./fi-edit-names-mat.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: NgForm,
        },
    ],
    providers: [{ provide: FiComponentsContainer, useExisting: FiEditNamesMatComponent }],
    standalone: false,
})
export class FiEditNamesMatComponent extends FiComponentsContainer implements OnInit, AfterViewInit {
    @Input() names: IContentLanguageLabelModel[];
    @Output() namesChange = new EventEmitter();
    @Input() languageId: number;
    @Input() inputLabel: string;
    @Input() inputHint: string;
    @Input() isNameRequiredFn: (name: IContentLanguageLabelModel) => boolean;

    @Output() afterViewInit = new EventEmitter();

    @ViewChildren('nameModel') nameModelList: QueryList<NgModel>;

    defaultLanguageId: number;

    constructor(private contentLanguagesService: ContentLanguagesService) {
        super();
    }

    ngOnInit() {
        this.defaultLanguageId = this.contentLanguagesService.GetDefaultLanguageId();
    }

    ngAfterViewInit() {
        this.afterViewInit.emit();
    }

    getNamePlaceholder(contentName) {
        if (this.isDefaultLanguage(contentName.ContentLanguageId)) return '';

        return this.getDefaultName();
    }

    isDefaultLanguage(languageId) {
        return languageId === this.defaultLanguageId;
    }

    getDefaultName() {
        const defaultName = this.names.find((name) => name.ContentLanguageId === this.defaultLanguageId);
        return defaultName ? defaultName.Value : '';
    }

    isShowNameHint() {
        return !this.getDefaultName();
    }

    isNameRequired(contentName: IContentLanguageLabelModel) {
        return this.isNameRequiredFn(contentName);
    }

    onNameChange(contentName: IContentLanguageLabelModel) {
        this.namesChange.emit();
    }
}
